import api from './api';

// Interfaz para el perfil anidado que viene del backend
export interface ProfileData {
  rol: string;
  telefono: string;
  direccion: string;
  fecha_nacimiento: string | null;
  rut: string | null;
  avatar: string | null;
  activo: boolean;
  nombre_completo: string;
  es_cliente: boolean;
  es_admin: boolean;
  es_repartidor: boolean;
  fecha_creacion: string;
  fecha_actualizacion: string;
}

// Interfaz para la respuesta completa del usuario
export interface UserProfileResponse {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  date_joined: string;
  profile: ProfileData;
  nombre_completo: string;
  rol: string;
  es_admin: boolean;
  es_cliente: boolean;
  es_repartidor: boolean;
}

// Interfaz simplificada para uso en componentes
export interface UserProfile {
  id: number;
  nombre_completo: string;
  telefono: string;
  rut?: string;
  direccion?: string;
  fecha_nacimiento?: string;
  foto_perfil?: string;
  fecha_registro: string;
}

export interface UpdateUserProfileData {
  nombre_completo?: string;
  telefono?: string;
  rut?: string;
  direccion?: string;
  fecha_nacimiento?: string;
  foto_perfil?: string;
}

// Obtener perfil del usuario actual
export const getUserProfile = async (): Promise<UserProfile> => {
  const response = await api.get('/auth/profile/');
  const data: UserProfileResponse = response.data;
  
  // Mapear la respuesta del backend a la estructura que espera el frontend
  return {
    id: data.id,
    nombre_completo: data.nombre_completo || `${data.first_name} ${data.last_name}`,
    telefono: data.profile?.telefono || '',
    rut: data.profile?.rut || '',
    direccion: data.profile?.direccion || '',
    fecha_nacimiento: data.profile?.fecha_nacimiento || '',
    foto_perfil: data.profile?.avatar || '',
    fecha_registro: data.date_joined,
  };
};

// Actualizar perfil del usuario
export const updateUserProfile = async (data: UpdateUserProfileData): Promise<UserProfile> => {
  const response = await api.put('/auth/profile/', data);
  const responseData: UserProfileResponse = response.data.user || response.data;
  
  // Mapear la respuesta
  return {
    id: responseData.id,
    nombre_completo: responseData.nombre_completo || `${responseData.first_name} ${responseData.last_name}`,
    telefono: responseData.profile?.telefono || '',
    rut: responseData.profile?.rut || '',
    direccion: responseData.profile?.direccion || '',
    fecha_nacimiento: responseData.profile?.fecha_nacimiento || '',
    foto_perfil: responseData.profile?.avatar || '',
    fecha_registro: responseData.date_joined,
  };
};

// Actualizar parcialmente el perfil
export const patchUserProfile = async (data: Partial<UpdateUserProfileData>): Promise<UserProfile> => {
  const response = await api.patch('/auth/profile/', data);
  const responseData: UserProfileResponse = response.data.user || response.data;
  
  return {
    id: responseData.id,
    nombre_completo: responseData.nombre_completo || `${responseData.first_name} ${responseData.last_name}`,
    telefono: responseData.profile?.telefono || '',
    rut: responseData.profile?.rut || '',
    direccion: responseData.profile?.direccion || '',
    fecha_nacimiento: responseData.profile?.fecha_nacimiento || '',
    foto_perfil: responseData.profile?.avatar || '',
    fecha_registro: responseData.date_joined,
  };
};
